/*
payments/fetch_paymentmethods
Gets the data and dispatches action when done.

*/
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view.js';

let state = {};
const register = dataflow.register;
let requestUrl = null;

function viewUpdate() {
	view.update({
		fetch_paymentmethods: state
	});
}

function parseToState(data) {
	if (data) {
		state = data;
		actions.fetchPaymentmethods(state);
	} else {
		console.error('fetch_paymentmethods:50:parseToState:can not read data', data);
	}
}

function getDataAndReplaceState() {
	state.error = false;
	function successHandler(data) {
		state.error = false;
		parseToState(data);
	}

	function errorHandler(err) {
		console.error('fetch_paymentmethods:error:', err);
		state.error = true;
		viewUpdate();
	}
	core.get(requestUrl, successHandler, errorHandler);
}

function registerActions() {
	function fetchPaymentmethods(payload) {
		if (payload.type === constants.SETUP_PAYMENT) {
			getDataAndReplaceState();
		}
	}
	register(fetchPaymentmethods);
}

export default {
	init(url) {
		/* set the ajax url to the paymentmethods*/
		requestUrl = url;
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/fetch-paymentmethods.js